import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoGastosService } from '../tipo-gastos.service';
@Component({
  selector: 'app-tipo-gastos-update',
  templateUrl: './tipo-gastos-update.component.html',
  styleUrls: ['./tipo-gastos-update.component.scss']
})
export class TipoGastosUpdateComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  @Input() element: any = {};

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService,
    public service: TipoGastosService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: [],
      nombre: ['', Validators.required],
      descripcion: [''],
    })
    this.form.patchValue(this.element);
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert(res.response, "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro.", "danger");
          if (err.error.response) {
            this.alerts.addAlert(err.error.response, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }
}
